import { render, staticRenderFns } from "./RepositionOrdersResume.vue?vue&type=template&id=379633a2&scoped=true&"
import script from "./RepositionOrdersResume.vue?vue&type=script&lang=js&"
export * from "./RepositionOrdersResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379633a2",
  null
  
)

export default component.exports